import { useState, useEffect } from "react";
import { DirectorUser } from "@po-management/types";
import { useApiClient } from "../../auth/useApiClient";

export function useDirectors(): { directors: DirectorUser[]; loading: boolean; error: string | null } {
  const [directors, setDirectors] = useState<DirectorUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { get } = useApiClient();

  useEffect(() => {
    get("/api/users/directors")
      .then((r) => r.json())
      .then((body: { success: boolean; data: DirectorUser[] }) => {
        if (body.success) setDirectors(body.data);
        else setError("Failed to load directors");
      })
      .catch(() => setError("Failed to load directors"))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { directors, loading, error };
}
